export default __webpack_public_path__ + "static/media/table.b0ec62a1.jpg";